import i from "react";
function f(r) {
  return r.replace(/-([a-z])/g, (o) => o[1].toUpperCase());
}
function l(r) {
  return r.split(";").reduce((o, p) => {
    let [t, n] = p.split(":");
    return t = t == null ? void 0 : t.trim(), n = n == null ? void 0 : n.trim(), t && n && (o[f(t)] = n), o;
  }, {});
}
function c(r) {
  if (Array.isArray(r))
    return r.map((e) => c(e));
  const o = {
    class: "className",
    for: "htmlFor",
    targetAttr: "targetattr"
    // Add more attribute conversions here as needed
  }, p = Object.keys(r.props).reduce((e, s) => {
    let a = r.props[s];
    s === "style" && typeof a == "string" && (a = l(a));
    const u = o[s] || s;
    return e[u] = a, e;
  }, {});
  p.key = r.key;
  const t = i.Children.map(r.props.children, (e) => typeof e == "string" ? e : c(e));
  return i.createElement(r.type, p, t);
}
export {
  c as convertAttributesInElement
};
